














import VueOptions from '@utils/VueOptions'

settings =
  name: 'CheckboxGroup'

  vue:
    props: ['value', 'options', 'actions', 'disabled']

    computed:
      selectedValue:
        get: -> @value
        set: (newValue) -> @$emit 'update:value', newValue

    methods:
      hiSelect: (option) ->
        if option.value in @selectedValue
          @actions?.unselect?(option)
        else
          @actions?.select?(option)

export default VueOptions.vue settings
